import React, { Component } from 'react';
import { Menu, Dropdown, Modal, Button } from 'antd';
import { connect } from 'react-redux';
import './DefaultLayout.scss'
import _ from 'lodash';
import logo from "../../images/logo-image.png";
import { logout } from '../../modules/user/action/user.actions'
import { Link } from "react-router-dom";
import { history } from '../../helpers/history'
import { updateEnv } from '../../services/endpoint';

/* eslint eqeqeq: 0 */
let tapCount = 0;
let timer = null;
export class Header extends Component {
  constructor() {
    super();
    this.deleteAccount = this.deleteAccount.bind(this);
    this.logout = this.logout.bind(this);
    this.state={
      showModal: false
    }
  }

  deleteAccount(e) {
    console.log("Deleting Account")
  }

  logout(e) {
    const { dispatch } = this.props;
    history.push('/');
    dispatch(logout());
    console.log("Logging out")
  }

  toggleEnv = (val) => {
    updateEnv(val)
    this.setState({showModal: false})
  }

  render() {
    const { user } = this.props
    const role = user && user.role && user.role.name
    const ProfileMenu = (
      <Menu>
        <Menu.Item>
          {
            role && role == "Provider" &&
            <Link to="/updateProfile">Profile</Link>
          }
        </Menu.Item>
        <Menu.Item>
          <Link to="/myBooking">My Booking</Link>
        </Menu.Item>
        <Menu.Item>
          <div onClick={() => { this.logout() }}>SignOut</div>
        </Menu.Item>
      </Menu>
    );

    return (
      <div className="nav-bar-background">

        <nav class="navbar navbar-inverse">
          <div class="container-fluid">
            <div class="navbar-header">
              <button type="button" class="navbar-toggle" data-toggle="collapse" data-target="#myNavbar">
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
                <span class="icon-bar"></span>
              </button>
              <div className="left-nav">
                {/* <Link to="/"> */}
                <img src={logo} onClick={() => {

                  tapCount++;
                  if (tapCount == 6) {
                    tapCount = 0;
                    // console.log("timerObject", timer)
                    clearTimeout(timer);
                    this.setState({showModal: true})
                    // console.log("timerObject after clear", timer)
                    // this.props.navigation.navigate('DeveloperPage', { navigation: this.props.navigation })
                    
                  } else {
                    timer = setTimeout(() => {
                      tapCount = 0
                      if(!this.state.showModal)
                        history.push('/')
                    }, 1000)
                  }
                }} className="nav-logo" alt="" />
                {/* </Link> */}
              </div>
            </div>
            <div class="collapse navbar-collapse" id="myNavbar">
              <div className="right-nav">
                <ul class="nav navbar-nav">
                  <li class="active">
                    <Link to="/">Home</Link>
                  </li>
                  <li>
                    <a href="#contact">Contact</a>
                  </li>
                  <li>
                    <Link to="/aboutUs">About Us</Link>
                  </li>
                  <li>
                    {
                      !user.token &&
                      <Link to="/login">Sign In</Link>
                    }
                  </li>
                  <li>
                    {
                      user.token &&
                      <Dropdown overlay={ProfileMenu} placement="bottomCenter" arrow>
                        <a>Profile</a>
                      </Dropdown>
                    }
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </nav>
        <Modal
          title="Choose Environment"
          visible={this.state.showModal}
          okText="Next"
          onCancel={() => this.setState({showModal: false})}
          footer={false}
        >
          <div className="">
            <div className="checkbox-main">
              <Button htmlType="button"
                className='customer-btn'
                onClick={() => { this.toggleEnv('production') }}
              >Production</Button>
            </div>
            <div className="checkbox-main">
              <Button htmlType="button"
                onClick={() => { this.toggleEnv('qa') }}
                className='customer-btn provider-btn'>QA</Button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { user } = state.authentication;
  return {
    user
  }
}

export default connect(
  mapStateToProps
)(Header);
